import React from "react";
import AgribusinessStack from "../AgribusinessStack/AgribusinessStack";

import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
// Main component for PPN Deployment for Plant Owners
export default function PlantOwner() {
  return (
    <>
      {/* Banner Section */}
      <AgribusinessStack
        classname="farmUpdateBanner" 
        level1="System Integrator"
        level2="Agribusiness"
        level3="Plant Owner / Food Processing Entrepreneur"
      />

      {/* Section representing PPN Deployment for Plant Owners */}
      <SolutionEcosystem
        title="PPN Deployment for Plant Owner / Food Processing Entrepreneur"
        type="PlantOwner"
        bodycopy="The CMN network enables food processing enterprises to source and sell, while PPN facilitates a decentralized, light-asset processing operational model for food processors."
      />
    </>
  );
}
